
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"270","y":"121","width":"225","height":"244","fill":"#FFF","rx":"12","ry":"12"}}),_c('path',{attrs:{"d":"M479.689 121.431H270.912c-8.23 0-14.91 6.705-14.91 14.958 0 8.251 6.68 14.95 14.91 14.95h165.322l-91.621 71.447-65.709-41.901-15.984 25.245 74.559 47.548c2.418 1.56 5.221 2.332 7.996 2.332 3.221 0 6.473-1.045 9.16-3.14l110.143-85.924v193.736H270.912c-8.23 0-14.91 6.699-14.91 14.946 0 8.257 6.68 14.959 14.91 14.959h208.777c8.234 0 14.914-6.702 14.914-14.959v-239.24c.001-8.252-6.679-14.957-14.914-14.957zm0 0","fill":"#1b80e4"}}),_c('path',{attrs:{"d":"M280.428 35.153c-3.404-2.841-7.967-4.069-12.26-3.168L29.566 76.84c-7.068 1.322-12.169 7.481-12.169 14.687v328.966c0 7.177 5.101 13.364 12.169 14.688l238.602 44.856c.893.177 1.818.271 2.744.271 3.459 0 6.828-1.199 9.516-3.445 3.432-2.836 5.393-7.083 5.393-11.512V46.671c-.001-4.458-1.962-8.676-5.393-11.518zm0 0","fill":"#2299f8"}}),_c('path',{attrs:{"d":"M151.609 360.683c-41.1 0-74.563-40.253-74.563-89.72 0-49.462 33.464-89.719 74.563-89.719 41.1 0 74.565 40.257 74.565 89.719 0 49.467-33.465 89.72-74.565 89.72zm0-149.53c-24.665 0-44.736 26.824-44.736 59.81 0 32.988 20.071 59.813 44.736 59.813 24.666 0 44.743-26.824 44.743-59.813 0-32.985-20.077-59.81-44.743-59.81zm0 0","fill":"#fcfcfc"}})])
          )
        }
      }
    